import { Component } from "@angular/core";

@Component({
    selector: "vds-header",
    templateUrl: "./header.component.html",
    styleUrl: "./header.component.css",
    standalone: true
})
export class VdsHeaderComponent {}
